import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const InvestigationStepMail = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 13C3.24 13 1 15.23 1 18C1 20.77 3.24 23 6 23C8.76 23 11 20.76 11 18C11 15.24 8.77 13 6 13ZM3.96 15.96H6C6.38 15.96 6.68 16.27 6.68 16.64C6.68 17.01 6.38 17.32 6 17.32H3.96C3.58 17.32 3.28 17.01 3.28 16.64C3.28 16.27 3.58 15.96 3.96 15.96ZM8.04 20.04H3.96C3.58 20.04 3.28 19.73 3.28 19.36C3.28 18.99 3.59 18.68 3.96 18.68H8.05C8.43 18.68 8.73 18.99 8.73 19.36C8.73 19.73 8.42 20.04 8.04 20.04Z"
      fill="currentColor"
    />
    <path
      d="M17 3H7C4 3 2 4.5 2 8V11.14C2 11.87 2.75 12.33 3.42 12.04C4.52 11.56 5.77 11.38 7.08 11.59C9.7 12.02 11.84 14.09 12.37 16.69C12.52 17.45 12.54 18.19 12.44 18.9C12.36 19.49 12.84 20.01 13.43 20.01H17C20 20.01 22 18.51 22 15.01V8C22 4.5 20 3 17 3ZM17.47 8.59L14.34 11.09C13.68 11.62 12.84 11.88 12 11.88C11.16 11.88 10.31 11.62 9.66 11.09L6.53 8.59C6.21 8.33 6.16 7.85 6.41 7.53C6.67 7.21 7.14 7.15 7.46 7.41L10.59 9.91C11.35 10.52 12.64 10.52 13.4 9.91L16.53 7.41C16.85 7.15 17.33 7.2 17.58 7.53C17.84 7.85 17.79 8.33 17.47 8.59Z"
      fill="currentColor"
    />
  </svg>
)

export default withDefaultStyles(InvestigationStepMail)
